import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreLabel = '查看更多' }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2.5">
          <span className="w-1 h-5 md:h-6 rounded-full bg-primary-500 shrink-0" />
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-600 mt-1.5 md:ml-3.5">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-accent-500 hover:text-accent-400 transition-colors cursor-pointer flex items-center gap-0.5 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}